var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioMutedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3vh",
    height: "3vh",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16Z",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9995 10.5C16.9995 10.299 16.8791 10.1175 16.6939 10.0393C16.5086 9.96119 16.2946 10.0016 16.1506 10.1419L13.2239 12.9927H11.4995C10.6711 12.9927 9.99951 13.6643 9.99951 14.4927V17.4817C9.99951 18.3101 10.6711 18.9817 11.4995 18.9817H13.2227L16.1491 21.8567C16.2928 21.9978 16.5071 22.039 16.6929 21.9611C16.8786 21.8832 16.9995 21.7014 16.9995 21.5V10.5ZM18.1464 14.1465C18.3417 13.9512 18.6583 13.9512 18.8536 14.1465L20 15.2929L21.1464 14.1465C21.3417 13.9512 21.6583 13.9512 21.8536 14.1465C22.0488 14.3417 22.0488 14.6583 21.8536 14.8536L20.7071 16L21.8536 17.1465C22.0488 17.3417 22.0488 17.6583 21.8536 17.8536C21.6583 18.0488 21.3417 18.0488 21.1464 17.8536L20 16.7071L18.8536 17.8536C18.6583 18.0488 18.3417 18.0488 18.1464 17.8536C17.9512 17.6583 17.9512 17.3417 18.1464 17.1465L19.2929 16L18.1464 14.8536C17.9512 14.6583 17.9512 14.3417 18.1464 14.1465Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMutedIcon);
export default __webpack_public_path__ + "static/media/audioMutedIcon.83deb1332cf20d61abe00ddc19770022.svg";
export { ForwardRef as ReactComponent };